import { render, staticRenderFns } from "./BaseAuditDropzone.vue?vue&type=template&id=8d7bc1e8"
import script from "./BaseAuditDropzone.vue?vue&type=script&lang=js"
export * from "./BaseAuditDropzone.vue?vue&type=script&lang=js"
import style0 from "./BaseAuditDropzone.vue?vue&type=style&index=0&id=8d7bc1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports